import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';

const CHART_OF_ACCOUNTS = '/accounting/chart-of-accounts';

/**
 * Chart of Accounts lives in accounting-ui now (ZEY-2804), behind the shell's /accounting iframe
 * route. The old /accounts screens are gone, but plenty still links to them — the Trial Balance,
 * P&L, Balance Sheet and Cash Flow drill-downs, journal grids, payment / receipt / shop views,
 * bookmarks — so each old URL forwards to its accounting-ui twin, keeping the account and the
 * date range (accounting-ui's account page reads dateFrom / dateTo from the query string).
 *
 * The add-account drawer other forms open (AccountAddComponent) is not a route and stays.
 */
export const ACCOUNTS_REDIRECT_ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: CHART_OF_ACCOUNTS },
  { path: 'add', redirectTo: `${CHART_OF_ACCOUNTS}/new` },
  {
    path: 'edit',
    redirectTo: ({ queryParams }) =>
      inject(Router).createUrlTree(
        queryParams['id'] ? [CHART_OF_ACCOUNTS, queryParams['id'], 'edit'] : [CHART_OF_ACCOUNTS],
      ),
  },
  {
    path: 'view',
    redirectTo: ({ queryParams }) => {
      const { id, ...rest } = queryParams;
      return inject(Router).createUrlTree(id ? [CHART_OF_ACCOUNTS, id] : [CHART_OF_ACCOUNTS], {
        queryParams: rest,
      });
    },
  },
  { path: '**', redirectTo: CHART_OF_ACCOUNTS },
];
